export const DATE_FORMAT = 'MM/dd/yyyy';

export const REGEXP_NUMBERS_ONLY = /[\d]/g;

export const MAX_INPUT_SYMBOLS = 10;
